import { useSelector } from 'react-redux';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';

/**
 * The `project-export-history` flag: one switch for the whole export-history
 * feature, read in one place.
 *
 * It gates three things that only make sense together:
 * - the "Lịch sử" tab in the export popover;
 * - progress polled per export record
 *   (`GET /projects/:id/exports/:exportId/progress`) instead of per export type
 *   (`GET /projects/:id/export-progress?type=`);
 * - the subtitle download going through the export pipeline, so it becomes a
 *   record in that history instead of a file built in the browser.
 *
 * The last two cannot be split: the per-type endpoint rejects `type=SRT`, so a
 * server-built SRT has no progress endpoint to poll without the record one.
 * Turning the flag off restores the previous flow end to end.
 */
const useExportHistoryEnabled = () => {
  const { getFeatureValue } = useFeatureFlags();
  const user = useSelector((state) => state.auth.user);

  return Boolean(
    getFeatureValue(FEATURE_KEYS.PROJECT_EXPORT_HISTORY, {
      userId: user?.id,
      email: user?.email,
      phoneNumber: user?.phoneNumber,
    }),
  );
};

export default useExportHistoryEnabled;
